import { useMutation } from '@apollo/client'
import { Event, EditEventVariables } from '../../types'
import { EDIT_EVENT } from './operations'


export const useEditEvent = () =>
  useMutation<Event, EditEventVariables>(EDIT_EVENT)